import { Flex, theme } from 'antd';
import dayjs from 'dayjs';
import LegacyArchiveMeetingPreviewCard from './LegacyArchiveMeetingPreviewCard';

const LegacyArchiveMeetingPreviewCardList = ({ groupedMeetings, onViewMeeting }) => {
    
  const {
    token: {
      colorPrimary,
      borderRadiusLG,
    },
  } = theme.useToken();

  if (!Array.isArray(groupedMeetings) || groupedMeetings.length === 0) {
    return null;
  }

  return (
    <>
      {groupedMeetings.map(([date, items]) => (
        <div key={date}>
          <Flex gap={16} align="center" justify="flex-start" style={{ fontSize: 24 }}>
            <div
              style={{
                backgroundColor: colorPrimary,
                padding: '8px 12px',
                borderRadius: borderRadiusLG,
                color: '#fff',
              }}
            >
              {dayjs(date).isValid() ? dayjs(date).format('DD') : '—'}
            </div>
            <div>{dayjs(date).isValid() ? dayjs(date).format('dddd, MMMM, YYYY') : date}</div>
          </Flex>
          <div>
            {items.map((item, index) => (
              <LegacyArchiveMeetingPreviewCard
                key={`archived-${item.key || index}`}
                item={item}
                onView={onViewMeeting}
              />
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default LegacyArchiveMeetingPreviewCardList;
